'use strict';
var monitoringTrainInfoTableTpl = require('./trainInfoTable.html');

module.exports = {
    template: monitoringTrainInfoTableTpl,
    bindings: {
        trains: '<',
        onLeftClick: '&', // This event is applied on officialId's column
        onRightClick: '&', // This event is applied on officialId's column
        onMouseOver: '&' // This event is applied on officialId's column
    },
    controllerAs: 'vm',
    controller: /*@ngInject*/ ["NgTableParams", "$filter", "$scope", "ProjectService", function (NgTableParams, $filter, $scope, ProjectService) {

        var vm = this;
        vm.dataRendered = false;
        vm.isIntegratedConsole = ProjectService.getSelectedProjectId() === 0 ? true : false;

        vm.headers = [{
            label: 'PROJECT',
            field: 'projectName',
            show: vm.isIntegratedConsole
        },
        {
            label: 'ID',
            field: 'officialId',
            show: true
        },
        {
            label: 'GPS',
            field: 'upToDate',
            show: true
        },
        {
            label: 'TRIP',
            field: 'currentTrip.endDate',
            show: true
        },{
            label: 'LOCATION',
            field: 'location.fullLocation',
            show: true
        },
        {
            label: 'IN_DEPOT',
            field: 'inDepot',
            show: true
        },{
            label: 'NEXT_TRIP',
            field: 'nextTrip.startDate',
            show: true
        },
        {
            label: 'SPEED',
            field: 'speed',
            show: true
        },{
            label: 'USERS',
            show: true
        },
        {
            label: 'LINKS',
            show: true
        },{
            label: 'DOWN',
            field: 'totalDownloadRate',
            tooltip: 'Download speed in mbit/s',
            show: true
        },
        {
            label: 'UP',
            field: 'totalUploadRate',
            tooltip: 'Upload speed in mbit/s',
            show: true
        },
        {
            label: 'DEVICE_ALARMS',
            show: true
        },{
            label: 'SIM_ALARMS',
            field: 'simAlarm.count',
            show: true
        },
        {
            label: 'OPENED',
            field: 'inService',
            show: true
        },
        {
            label: 'CHECKED',
            field: 'timestamp',
            show: true
        },
        {
            label: 'LAST_SEEN',
            field: 'lastSeen',
            tooltip: 'Upload speed in mbit/s',
            show: true
        }
    
    ];

     
        vm.$onInit = function () {

            vm.trainInfoTblParams = new NgTableParams({
                page: 1,            // show first page
                count: 500,          // count per page
                filter: {},
                sorting: { officialId: 'asc' }
            }, {
                    counts: vm.trains && vm.trains.length <= 10 ? [] : [10, 25, 50, 100, 500],
                    total: (vm.trains ? vm.trains.length : 0), // length of data   
                    getData: function (params) {

                        if (vm.trains && vm.trains.length > 0) {
                            var sortedData = params.sorting() ? $filter('orderBy')(vm.trains, params.orderBy()) : vm.trains;

                            params.total(sortedData.length);

                            return sortedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
                        } else {
                            vm.dataRendered = true;
                            params.total(0);
                            return [];
                        }

                    }.bind(vm)
                });
        };

        vm.$onChanges = function () {

            vm && vm.trainInfoTblParams && vm.trainInfoTblParams.reload();
        };

        $scope.$on('ngRepeatFinished', function () {
            vm.dataRendered = true;
        });

        vm.sortData = function (field, event) {

            var sortingValObj = (event.shiftKey ? vm.trainInfoTblParams.sorting() : {});

            if (sortingValObj.hasOwnProperty(field)) {
                sortingValObj[field] = ((sortingValObj[field] === 'asc') ? 'desc' : 'asc');
            } else {
                sortingValObj[field] = (vm.trainInfoTblParams.isSortBy(field, 'asc') ? 'desc' : 'asc');
            }

            vm.trainInfoTblParams.sorting(sortingValObj);
            vm.trainInfoTblParams.reload();
        };

        vm.onOfficialIdLeftClick = function(train) {  
            vm.onLeftClick({ train: train });           
        };
    
        vm.onOfficialIdRightClick = function(train) {   
            vm.onRightClick({ train: train });           
        };

        vm.onOfficialIdMouseOver = function() {
            vm.onMouseOver();
        };

    }]
};
